import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export const ProductionSettingsComponent = ({ selectProductionSettings, handleInnerFormChange }: any) => {

    return (
        <>
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="Production Plan Number Prefix"
                            name="ProductionPlanNumberPrefix"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'ManufacturingSettings.ProductionPlanNumberPrefix',
                                    selectProductionSettings?.ManufacturingSettings
                                )
                            }}
                            type="text"
                            value={selectProductionSettings?.ManufacturingSettings?.ProductionPlanNumberPrefix}
                        />
                        <InputContainer
                            label="Indent Number Prefix"
                            name="IndentNumberPrefix"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'ManufacturingSettings.IndentNumberPrefix',
                                    selectProductionSettings?.ManufacturingSettings
                                )
                            }}
                            type="text"
                            value={selectProductionSettings?.ManufacturingSettings?.IndentNumberPrefix}
                        />
                        <InputContainer
                            label="Return Number Prefix"
                            name="ReturnNumberPrefix"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'ManufacturingSettings.ReturnNumberPrefix',
                                    selectProductionSettings?.ManufacturingSettings
                                )
                            }}
                            type="text"
                            value={selectProductionSettings?.ManufacturingSettings?.ReturnNumberPrefix}
                        />
                        <InputContainer
                            label="Output Number Prefix"
                            name="OutputNumberPrefix"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'ManufacturingSettings.OutputNumberPrefix',
                                    selectProductionSettings?.ManufacturingSettings
                                )
                            }}
                            type="text"
                            value={selectProductionSettings?.ManufacturingSettings?.OutputNumberPrefix}
                        />
                    </div>
                }
                expandedPanel="Production Settings"
                headerTitle="Production Settings"
            />
        </>
    )
}
export default ProductionSettingsComponent;
